import { Skeleton } from 'antd';
import { QuestionGrid, QuestionItem, QuestionItemColumn } from '../submission-section-summary-v3.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionSummaryQuestionItems = function SectionSummaryQuestionItems(_ref) {
  var sectionIndex = _ref.sectionIndex,
      questionItems = _ref.questionItems,
      isLoading = _ref.isLoading,
      label = _ref.label,
      onSelectQuestion = _ref.onSelectQuestion;

  if (isLoading) {
    return /*#__PURE__*/_jsx(Skeleton, {
      active: true
    });
  }

  if (!questionItems.length) {
    return /*#__PURE__*/_jsxs("i", {
      children: ["(", label.notHaveAnyQuestionInThisSection, ")"]
    });
  }

  return /*#__PURE__*/_jsx(QuestionGrid, {
    gutter: 0,
    children: questionItems.map(function (questionItem) {
      return /*#__PURE__*/_jsx(QuestionItemColumn, {
        children: /*#__PURE__*/_jsx(QuestionItem, {
          $isSelected: Boolean(questionItem.isSelected),
          $isAnswered: questionItem.isAnswered,
          onClick: function onClick() {
            return onSelectQuestion(sectionIndex, questionItem);
          },
          children: questionItem.displayIndex
        })
      }, questionItem.key);
    })
  });
};